import React from "react";
import { FaTrophy } from "react-icons/fa";

const Resume = (props) => {
  return (
    <section id="resume" className="resume">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Resume</h2>
          <p>A life &amp; work showcase</p>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <h3 className="resume-title">Summary</h3>
            <div className="resume-item pb-0">
              <h4>Kunal Karnik</h4>
              <p>
                <em>
                  A problem solver at core. A software developer having hands on
                  coding experience with languages including TypeScript, Kotlin,
                  Swift, COBOL, Python, and more.
                </em>
              </p>
              <p>
                <em>
                  Over 8 years of experience in the IT &amp; ITes industry,
                  delivering high-quality software products, leading teams and
                  projects, with a strong focus on quality, reliability,
                  operational excellence and customer satisfaction.
                </em>
              </p>
              <ul>
                <li>Pune, India</li>
                <li>hello@kunalkarnik.com</li>
                <li>+91 844 658 0921</li>
              </ul>
            </div>
            <h3 className="resume-title">Education</h3>
            <div className="resume-item">
              <h4>Master of Technology</h4>
              {/* <h5>2016 - 2018</h5> */}
              <p>
                <em>
                  Veermata Jijabai Technological Institute (VJTI), Mumbai, India
                </em>
              </p>
              <p>CGPA: 8.34/10.0</p>
            </div>
            <div className="resume-item">
              <h4>Bachelor of Engineering </h4>
              {/* <h5>2013 - 2016</h5> */}
              <p>
                <em>University of Mumbai, Mumbai, India</em>
              </p>
              <p>CGPA: 8.05/10.0</p>
            </div>
            <div className="resume-item">
              <h4>Diploma in Engineering </h4>
              {/* <h5>2009 - 2013</h5> */}
              <p>
                <em>
                  Maharashtra State Board of Technical Education, Mumbai, India
                </em>
              </p>
              <p>Aggregate Percentage: 84.65%</p>
            </div>
            <h3 className="resume-title">Certifications and Achievements</h3>
            <div className="resume-item ">
              <h4>
                <FaTrophy /> Full Stack MERN Course with React, NodeJS, MongoDB,
                Express
              </h4>
              <p>
                <em> By Oak Academy </em>
              </p>
            </div>
            <div className="resume-item ">
              <h4>
                <FaTrophy /> The Complete ReactJs Course - Basics to Advanced
              </h4>
              <p>
                <em>
                  By EdYoda Digital University, Qaifi Khan, Mavludin
                  Abdulkadirov
                </em>
              </p>
            </div>
            <div className="resume-item ">
              <h4>
                <FaTrophy /> iOS & Swift - The Complete iOS App Development
                Bootcamp
              </h4>
              <p>
                <em> By Dr. Angela Yu, London App Brewery </em>
              </p>
            </div>
            <div className="resume-item ">
              <h4>
                <FaTrophy /> The Complete Android 15 Course - Master Java &
                Kotlin
              </h4>
              <p>
                <em> By Abbass Masri, Dr. Ali Alaeddine </em>
              </p>
            </div>
            <div className="resume-item ">
              <h4>
                <FaTrophy /> IELTS
              </h4>
              <p>
                <em> Overall Band Score of 7.5 </em>
              </p>
            </div>
            <div className="resume-item ">
              <h4>
                <FaTrophy /> Digital Manufacturing with Autodesk Fusion 360
              </h4>
              <p>
                <em> By Autodesk </em>
              </p>
            </div>
            <div className="resume-item ">
              <h4>
                <FaTrophy /> Certificate course in German
              </h4>
              <p>
                <em> By Mumbai University </em>
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <h3 className="resume-title">Professional Experience</h3>
            <div className="resume-item">
              <h4>Biz4Solutions Pvt. Ltd., Pune, India</h4>
              <p>
                <em>Lead Software Engineer</em>
              </p>
              <h5>Mar 2022 - Present</h5>
              <ul>
                <li>
                  Responsible for end-to-end software delivery for mobile
                  applications.
                </li>
                <li>
                  Managed teams building mobile applications with React-Native,
                  Kotlin & Swift along with Web projects in next.js and node.js
                  backend.
                </li>
                <li>
                  Along with Techinical delivery, the role included pre-sales
                  activities like scoping, estimations to post production
                  support, analysis and maintenance.
                </li>
                <li>
                  Initiated and led a Kotlin Multiplatform (KMP) initiative,
                  driving feasibility assessment, competency building, and team
                  enablement with strategic foresight.
                </li>
                <li>
                  Engineered high-performance, secure, and scalable mobile
                  applications with unmatched technical precision.
                </li>
              </ul>
            </div>
            <div className="resume-item">
              <h4>Whitehat Education Technology Pvt. Ltd., Mumbai, India</h4>
              <p>
                <em>Software Developer</em>
              </p>
              <h5>Sept 2020 - Mar 2022 </h5>
              <ul>
                <li>
                  Delivered a web portal for live one to one teaching sessions
                  built in React - NextJs.
                </li>
                <li>
                  Integrated Whereby for Video sessions. Later migrated to
                  Twilio.
                </li>
                <li>
                  Played key role in developing and launching curriculum which
                  included apps developed using React-native, games on
                  Javascript, Python data science and much more.
                </li>
                <li>
                  Built and managed support ops team for curriculum related
                  queries handling issues with throughtout 99% CSAT.
                </li>
                <li>
                  Was actively involved in identifying KRAs for curriculum
                  support team considering organizational OKRs. Also developed
                  and delivered KPIs for performance evaluation of team.
                </li>
              </ul>
            </div>
            <div className="resume-item">
              <h4>KVAR Technologies PVT. LTD., Mumbai, India</h4>
              <p>
                <em>Business Associate</em>
              </p>
              <h5>Jan 2020 - Aug 2020</h5>
              <ul>
                <li>
                  Developed a <em>Flask</em> application for Andon System.
                </li>
                <li>
                  It included network communication using WebSockets and
                  multi-threading for establishing full duplex communication
                  with multiple hardware units(ESP microcontroller based).
                </li>
                <li>Used SMTP for sending email alerts.</li>
                <li>
                  Created web application using Django for production monitoring
                  and Andon.
                </li>
                <li>
                  It was a full-stack development including Database design,
                  creating views, Templating and frontend development using
                  JQuery and Bootstrap.
                </li>
                <li>
                  Built RESTful API using <em>Django REST Framework</em> for
                  communication with hardware units.
                </li>
              </ul>
            </div>
            <div className="resume-item">
              <h4>INFOSYS LTD., Pune, India</h4>
              <p>
                <em>Systems Engineer</em>
              </p>
              <h5>Aug 2018 - Jan 2020</h5>
              <ul>
                <li>
                  Being consistent top performer in Training, got allocated to
                  client billable production project in Legacy (Mainframe)
                  Modernization team even before completion of training.
                </li>
                <li>
                  Developed and coded extraction &amp; transformation logic in
                  COBOL for data migration of Transactions data of a US based
                  Insurance company.
                </li>
                <li>
                  Responsibilities included requirement analysis based on
                  mapping provided by the client, coding transformation logic in
                  COBOL, extracting data from VSAM datasets and DB2 databases,
                  loading the datasets in MS SQL server to check data sanity,
                  writing SQL queries for testing and maintaining code with
                  version control tools like ChangeMan,Endevor.
                </li>
                <li>
                  Hands on experience of using JIRA and ALM for defect logging
                  and Application Lifecycle Management.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
